import {createContext} from "react";
import {IServiceContext} from "../types/service.interface";

const ServiceScreen = createContext<IServiceContext>({});

export default ServiceScreen;
